import { call, put, select, takeLatest } from 'redux-saga/effects'
import BILLING_API from 'api/billing/v1'
import { notificationShow } from 'modules/Notifications/actions'
import { SET_INVOICES_DATA } from 'modules/Finance/Invoices/store/types'

function* fetchInvoices({ payload }) {
  const { data: invoices = [] } = yield select((state) => state['finance/invoices'])
  try {
    yield put({
      type: SET_INVOICES_DATA,
      payload: { loading: true },
    })

    const { response, error } = yield call(BILLING_API.fetchInvoices, {
      params: {
        ...payload,
      },
    })

    if (error) {
      throw error
    }

    const { data, pagination } = response

    yield put({
      type: SET_INVOICES_DATA,
      payload: {
        data: [...invoices, ...data],
        pagination,
      },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    yield put({
      type: SET_INVOICES_DATA,
      payload: {
        failed: true,
      },
    })
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_INVOICES_DATA,
      payload: { loading: false, loaded: true },
    })
  }
}

export default function* Sagas() {
  yield takeLatest('FINANCE/FETCH_INVOICES', fetchInvoices)
}
